var map = {
	"./FMCG.mp4": 2602,
	"./endustriyel.mp4": 3675,
	"./eticaret.mp4": 5434,
	"./karpuzlar.mp4.mp4": 2112,
	"./kozmetik.mp4": 1557,
	"./otomotiv.mp4": 1258,
	"./perakende.mp4": 3738,
	"./takeaway.mp4": 7192,
	"./yasmeyvesebze.mp4": 6075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2225;